'use client';

import { useEffect, useState } from 'react';

import { OpenInBrowser } from '@lichtblick/icons';
import { LichtblickSession } from '@lichtblick/types';
import { fetchFile } from '@lichtblick/utils';

import { ImageRow } from './ChatMessageImageRow.styles';

import { Image } from '../Image';

type ChatMessageImageRowProps = {
  expectedMaxWidth?: number;
  hasModal?: boolean;
  idx?: number;
  image: {
    contentType: string;
    url: string;
  };
  isFileBrowser?: boolean;
  isInCarousel?: boolean;
  isInListView?: boolean;
};

const _fetchImage = async (session: LichtblickSession | null, image: { contentType: string; url: string }) => {
  if (!session) {
    throw new Error('No session found');
  }

  const result = (await fetchFile(session, image)) as { data: number[]; name: string };

  return result;
};

export const ChatMessageImageRow = ({
  expectedMaxWidth = 360,
  hasModal = true,
  idx,
  image,
  isFileBrowser,
  isInCarousel,
  isInListView = true,
}: ChatMessageImageRowProps) => {
  const [imageSrc, setImageSrc] = useState<string>('');
  // const [isLoading, setIsLoading] = useState(true);
  // const scale = 14.4;

  useEffect(() => {
    setImageSrc(image.url ?? '');
    // setIsLoading(true);
  }, [image.url]);

  const handleOpenInNewTab = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (imageSrc) {
      window.open(imageSrc, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ImageRow>
      {/* {isLoading && (
        <Skeleton
          height={`${expectedMaxWidth / scale}rem`}
          style={{ zIndex: 0 }}
          width={`${expectedMaxWidth / scale}rem`}
        />
      )} */}
      {imageSrc && (
        <Image
          alt="test"
          counter={idx ? idx + 1 : undefined}
          expectedMaxWidth={expectedMaxWidth}
          fill
          hasModal={hasModal}
          isFileBrowser={isFileBrowser}
          isInCarousel={isInCarousel}
          src={imageSrc}
          // onLoad={() => setIsLoading(false)}
          // onError={() => setIsLoading(false)}
        />
      )}
      {isInListView && isFileBrowser && <OpenInBrowser color="primary" onClick={handleOpenInNewTab} />}
    </ImageRow>
  );
};
